import { useAuthUser } from "../../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin } from 'antd';
import Table from '../../../TableResizable';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import Tab2 from './ta1';


//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import InputForm from "../../../InputT";
import RadioBox from "../../../Radiox";

import { useAuthHeader } from "../../../../Services/Auth/sessionAuth";
import axios from "axios";
import Data from '../../../../Data/Data.json';
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import DataSelect from '../../../../Types/DataSelect'
import SelectOption from "../../../SelectOption";




const VisualBlocage = () => {

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(true)
    const [form] = Form.useForm();
    const [Valid, setValid] = useState(true);
    const [Actual, setActual] = useState(false)
    const authHeader = useAuthHeader()
    const [state, setstate] = useState(false)


    // Handle
    function HandleActualiser() {
        setActual(true)
        localStorage.clear();
        setSelectedRowKeys([]);
    }

    //state pour la recherche
    const [SearchR, SetSearchR] = useState<string>("");
    // usestate pour recuperer les données du tableau  
    const [donnees, setData] = useState<DataType[]>([]);

    // Gestion des Items 
    const items: TabsProps['items'] = [

        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Visualisation Montant Bloquer
                </span>
            ),
            children: <Tab2 form={form} />, //form={form}
        },

    ];

    //column du tableau 
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro dossier',
            dataIndex: 'REFMARQ',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.REFMARQ)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.codage)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NUMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NOMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Numéro compte',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'Intitulé ',
            dataIndex: 'NOMCPT',
        },
        {
            title: 'Montant',
            dataIndex: 'MONTPR',
        },
        {
            title: 'Crée le',
            dataIndex: 'DATCRE',
        },
        {
            title: 'Date fin ',
            dataIndex: 'DATEFM',
        }
    ];


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))

    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }


    //function pour lire loadData

    // setTimeout(() => {
    //     if (donnees.length == 0) {
    //         if (!state) {
    //             setstate(true)
    //             Consultableau()
    //         }

    //     }
    //     try {
    //         let reset = localStorage.getItem(Data.LocalVariable.reset)
    //         if (reset == "1") {
    //             setData([])
    //         }
    //     }
    //     catch (error) {
    //         console.log(error)
    //     }
    // }, 0.1);



    ///function pour remplir les données du tableau 
    function Consultableau() {


        if (form.getFieldValue("ETAT") == "VALIDE") {

            //alert(form.getFieldValue("ETAT"))

            let a = Perss.codage;
            let b = '2';
            if (!loading) {
                setLoading(true)
                
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.AllReadMontantBloquer,
                    headers: {
                        'Cyphercodage': Crypter.encrypt(a),
                        'Cyphertrie': Crypter.encrypt(b),
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json',
                    },
                };

                //MAPPING DANS LE TABLEAU
                let dat: DataType[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            let datas = response.data.Result;
                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    REFMARQ: val.REFMARQ,
                                    codage: val.codage,
                                    NUMCPT: val.NUMCPT,
                                    NOMCPT: val.NOMCPT,
                                    MONTPR: val.MONTPR,
                                    DISPON: val.DISPON,
                                    DATCRE: val.DATCRE,
                                    DATEFM: val.DATEFM,
                                     MOTIFM: val.MOTIFM,
                                })
                            })
                            setData((dat))

                        } else {
                            SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        } else if (form.getFieldValue("ETAT") == "INVALIDE") {

            //alert(form.getFieldValue("ETAT"))

            let a = Perss.codage;
            let b = '3'
            if (!loading) {
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.AllReadMontantBloquer,
                    headers: {
                        'Cyphercodage': Crypter.encrypt(a),
                        'Cyphertrie': Crypter.encrypt(b),
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json',
                    },
                };

                //MAPPING DANS LE TABLEAU
                let dat: DataType[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            let datas = response.data.Result;
                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    REFMARQ: val.REFMARQ,
                                    codage: val.codage,
                                    NUMCPT: val.NUMCPT,
                                    NOMCPT: val.NOMCPT,
                                    MONTPR: val.MONTPR,
                                    DISPON: val.DISPON,
                                    DATCRE: val.DATCRE,
                                    DATEFM: val.DATEFM,
                                    MOTIFM: val.MOTIFM,
                                })
                            })
                            setData((dat))

                        } else {
                            SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        } else {
            SweetAlert.fire({ text: "Choisir l'état à afficher", icon: "warning" })
        }
        
    }


    ///function pour remplir les données du tableau 
    const onFinish = () => {


    };

    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    const dataOption2: DataSelect[] = [
        { label: " Blocage Invalide ", value: "INVALIDE" },
        { label: " Blocage Valide ", value: "VALIDE" }
    ]



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { form.resetFields() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost"  block>
                                    Afficher
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={true} onClick={() => { }} type="ghost" block  >
                                    Visualiser
                                </Button>
                                <Button size='large' className='bt_add' disabled={true} onClick={() => { }} type="ghost" block  >
                                    Imprimer
                                </Button> */}
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                                        <Box fontStyle="inherit" className='border-left ' > 
                                            <legend> Visualisation des montants bloqués  </legend>
                                            <Box className='border' style={{display: "flex",width: '100%'}} sx={{ mb: 1 }}>

                                                  <Box className='border'  style={{ width: '100%' }} >
                                                    <Form.Item  >
                                                        < SelectOption disabled={false} Option={dataOption2} width={100} label="Catégorie" Size={'50%'} name="ETAT" />
                                                    </Form.Item>
                                                </Box>
                                                {/* <Box style={{  marginBottom: 12, marginTop: -10 }}>
                                                    <RadioBox LibValue1="Non Valide" Value1="INVALIDE" Value2="VALIDE" libVlue2="Valide" name="ETAT" />
                                                </Box> */}
                                                
                                            </Box>
                                                <Box className='border'  style={{ width: '100%' }} sx={{ mb: 1 }}>
                                                    <InputForm notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string"  />
                                                </Box>

                                            <Box className='border'  style={{ width: '100%' }} sx={{ mb: 1 }}>
                                                <Spin spinning={loading}>
                                                    <Table dataSource={donnees}  columns={columns} style={{ textAlign: "center", width: '100%' }} scroll={{ y: 400, x: 400 }} size='small' pagination={false} />
                                                </Spin>
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}


export default VisualBlocage;